<template>
  <a-input
    placeholder="Correo electrónico"
    :max-length="40"
    v-model:value="inputValue"
    @keydown.space.prevent
    @keyup="formatEmails"
    v-bind="$attrs"
  >
    <template #suffix>
      <a-button
        type="link"
        @click="clearInput"
        style="padding: 0; margin: 0; width: 20px; height: 20px; line-height: 1"
        tabindex="-1"
      >
        <DeleteOutlined class="red-icon" v-show="inputValue" />
      </a-button>
    </template>
  </a-input>
</template>

<script>
import { computed } from 'vue';
import emailsHelper from '@/utils/emailValidator';
import { DeleteOutlined } from '@ant-design/icons-vue';

export default {
  props: {
    modelValue: {
      type: String,
      default: ''
    }
  },
  components: {
    DeleteOutlined
  },
  emits: ['update:modelValue'],
  /**
   * Setup function for the input component.
   *
   * This function initializes the component's reactive properties and methods.
   * It sets up a computed property `inputValue` to handle the two-way binding
   * of the `modelValue` prop, emitting changes back to the parent component.
   *
   * It includes the method:
   * - `formatEmails`: Validates the input email value to a standard format using `emailsHelper`.
   *
   * @param {Object} props - The props passed to the component.
   * @param {Function} emit - The function to emit events to the parent component.
   * @returns {Object} - Returns the computed property and methods for the component.
   */
  setup(props, { emit }) {
    const inputValue = computed({
      get: () => props.modelValue,
      set: (val) => emit('update:modelValue', val)
    });

    /**
     * Validates the input email value to a standard format using `emailsHelper`.
     *
     * If the input value is not empty, it validates it using `emailsHelper.validateEmail` and
     * updates the `inputValue` property with the validated value.
     */
    const formatEmails = () => {
      if (inputValue.value) {
        const formattedValue = emailsHelper.validateEmail(inputValue.value);
        emit('update:modelValue', formattedValue);
      }
    };

    const clearInput = () => {
      emit('update:modelValue', '');
    };

    return { inputValue, formatEmails, clearInput };
  }
};
</script>
